import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

interface GetMezzanineMasterDataParams {
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const getMezzanineMasterDataAPI =
  ({ onSuccess, onError }: GetMezzanineMasterDataParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(
        "/mezzanine-storage-type/settings",
      );
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to fetch settings");
        onError?.();
      }
    } catch (error: any) {
      console.error("Get Mezzanine Master Data error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to fetch settings";
      message.error(errorMessage);
    }
  };

interface UpdateMezzanineMasterDataParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateMezzanineMasterDataAPI =
  ({ payload, onSuccess, onError }: UpdateMezzanineMasterDataParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        "/mezzanine-storage-type/settings",
        payload,
      );
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Settings updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update settings");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update Mezzanine Master Data error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to update settings";
      message.error(errorMessage);
    }
  };
